export class LearningContinueRequest {
  termIds: string[];
  itemSize: number;
  currentIndex: number;
  currentPage: number;

  constructor(
    termIds: string[],
    itemSize: number,
    currentIndex: number,
    currentPage: number
  ) {
    this.termIds = termIds;
    this.itemSize = itemSize;
    this.currentIndex = currentIndex;
    this.currentPage = currentPage;
  }
}
